import { adminActions, pharmagapTransaction, successSelector } from '@pharmaplan/common';

import { IDynamicTableObject } from '../../../components/DynamicTable/types';
import { getDayMonthDateYear } from '../../../components/Reports/helpers';
import { DynamicTableCell } from '../../../helpers/Constants';
import { useAppSelector } from '../../useAppSelector';
import strings from '../../../localization';

const { text } = DynamicTableCell;

const usePharmagapTransactions = () => {
  const success = useAppSelector((state) =>
    successSelector([adminActions.getPharmagapTransaction], state));

  const transaction = useAppSelector(pharmagapTransaction);

  const { bookingDetails } = transaction ?? {};

  const headers = [
    {
      key: '0',
      label: strings.bookingDate,
    },
    {
      key: '1',
      label: strings.shiftCode,
    },

    {
      key: '2',
      label: strings.availabilityCode,
    },
  ];

  const rows = () =>
    (bookingDetails ?? [])?.map((item) => {
      const { availabilityCode, bookingId, shiftCode, selectedDate } = item ?? {};
      const parsedDate = getDayMonthDateYear(selectedDate);
      return {
        key: bookingId,
        data: [
          {
            key: 0,
            value: parsedDate,
            type: text,
          },
          {
            key: 1,
            value: shiftCode,
            type: text,
          },
          {
            key: 2,
            value: availabilityCode,
            type: text,
          },

        ],
      };
    });

  const table: IDynamicTableObject = {
    rows: rows(),
    headers,
    headerBar: [],
  };

  return { table, success };
};

export default usePharmagapTransactions;
